import theme from '../themes/default'

export default {
  'overwrite-navbar-lite': {
    color: '#fff',
    background: '#614D4A',
    height: '45px',
    paddingTop: 10,
    '& img': {
      width: '25px',
    },
  },
  'right-sidebar': {
    color: '#fff',
    'letter-spacing': '2px',
    'font-size': '14px',
  },
  'edit-text': {
    'font-size': '18px',
    color: '#fff',
    'letter-spacing': '4px',
  },
  'order-filter': {
    'font-size': '18px',
    color: '#fff',
    'letter-spacing': '4px',
    padding: '10px 5px 10px 5px',
    height: '40px',
  },
  'active-order-filter': {
    'font-size': '18px',
    color: '#D5AD40',
    'box-shadow': '#D5AD40 0px -4px 0px inset',
    'letter-spacing': '4px',
    padding: '10px 5px 10px 5px',
    height: '40px',
  },
}



// WEBPACK FOOTER //
// ./src/assets/styles/components/NavBarLite.js